import * as types from "./types";

const clearStore = () => ({
  type: types.CLEAR_STORE
});

const changeDateRange = range => ({
  type: types.CHANGE_DATE_RANGE,
  payload: range
});

const fetchDashboardData = () => ({
  type: types.FETCH_DASHBOARD_DATA
});

const fetchingDashboardDataError = error => ({
  type: types.FETCHING_DASHBOARD_DATA_ERROR,
  payload: error
});

const fetchingDashboardDataSuccess = data => ({
  type: types.FETCHING_DASHBOARD_DATA_SUCCESS,
  payload: data
});

const fetchInvoiceTypes = () => ({
  type: types.FETCH_INVOICE_TYPES
});

const fetchingInvoiceTypesError = error => ({
  type: types.FETCHING_INVOICE_TYPES_ERROR,
  payload: error
});

const fetchingInvoiceTypesSuccess = data => ({
  type: types.FETCHING_INVOICE_TYPES_SUCCESS,
  payload: data
});

const setType = selectedType => ({
  type: types.SET_TYPE,
  payload: selectedType
});

export {
  changeDateRange,
  fetchDashboardData,
  fetchingDashboardDataError,
  fetchingDashboardDataSuccess,
  fetchInvoiceTypes,
  fetchingInvoiceTypesError,
  fetchingInvoiceTypesSuccess,
  clearStore,
  setType
};
